window.addEventListener('load', function() {
    $('form#login').on('submit', function(e){
        //console.log(ajax_login_object.loadingmessage); - Sending user info szoveg
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_login_object.ajaxurl,
            data: { 
                'action': 'ajaxlogin',
                'username': $('form#login #logusername').val(), 
                'password': $('form#login #logpassword').val(), 
                'security': $('form#login #security').val(),
                'remember' : $('form#login #logremember').prop('checked') },
            success: function(data){
                //console.log(data.message); - Hiba vagy success
                if (data.loggedin == true){
                    $('.loginLink').addClass('hidden');
                    $('.logoutLink').removeClass('hidden');
                    $('.headerLogin').removeClass('open');
                }
            }
        });
        e.preventDefault();
    });
    $('form#register').on('submit', function(e){
        //console.log(ajax_login_object.loadingmessage); - Sending user info szoveg
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_login_object.ajaxurl,
            data: { 
                'action': 'ajaxregister',
                'username': $('form#register #regusername').val(), 
                'password': $('form#register #regpassword').val(), 
                'security': $('form#register #security').val(),
                'gdpr' : $('form#register #gdpr').prop('checked') },
            success: function(data){
                //console.log(data.message); - Hiba vagy success
                if (data.loggedin == true){
                    $('.loginLink').addClass('hidden');
                    $('.logoutLink').removeClass('hidden');
                }
            }
        });
        e.preventDefault();
    });
    $('.logout').on('click', function(e){
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_login_object.ajaxurl,
            data: { 'action': 'ajaxlogout', },
            success: function(data){
                //console.log(data.message); - Hiba vagy success
                if (data.loggedout == true){
                    $('.loginLink').removeClass('hidden');
                    $('.logoutLink').addClass('hidden');
                }
            }
        });
        e.preventDefault();
    });
});
